import React from "react";
import {Pane} from "evergreen-ui";
import {useSelector} from "react-redux";

export default function RainFloodTable() {

    const tableStyle = {
        tableLayout: "fixed",
        width: "1350px",
        borderCollapse: "collapse",
        marginBottom: "90px",
        fontFamily: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
    }

    const rainFloodConstructor = useSelector(state => state.rainFloodConstructor)
    const filters = rainFloodConstructor.filters

    const createTable = () => {

        return (
            <table border={"1px"} style={tableStyle}>
                <tr>
                    <th width={250} rowSpan={2}>Наименование источника</th>
                    <th colSpan={3}>Период паводка</th>
                    <th rowSpan={2}>Слой стока за паводок, мм</th>
                    <th rowSpan={2}>Слой осадков, мм</th>
                    <th rowSpan={2}>Коэффициент стока</th>
                    <th rowSpan={2}>Дата и время прохождения пика, ч, мин</th>
                    <th rowSpan={2}>Модуль максимального стока, л/с·км</th>
                </tr>
                <tr>
                    <th>Начало</th>
                    <th>Конец</th>
                    <th>Продол-ть, сут</th>
                </tr>

                {filters.map(filter =>
                    <tr>
                        <td align={"center"} width={250} height={20}>{filter.rainfall.type.name}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )}
            </table>
        );
    }



    return (
        <Pane marginTop={30} width={1350}>
            {createTable()}
        </Pane>
    )
}